import { render, staticRenderFns } from "./ElixioPayModuleLayout.vue?vue&type=template&id=5236c2b3&"
import script from "./ElixioPayModuleLayout.vue?vue&type=script&lang=js&"
export * from "./ElixioPayModuleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports